// Info: Import NPM Dependancies
import { createSlice, createSelector } from '@reduxjs/toolkit';

// Info: Import Local Dependancies
import { RootState } from './store';

export enum API_STATUS {
  NOT_STARTED = 'NOT_STARTED',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED'
}
const initialState = {
  isSiteCorePending: true,
  app: {

  },
  state: "",
  systemMessage: "",
  error: null as any,
  authToken: '',
  errorMessage:'',
};

const sitecoreReducer = createSlice({
  name: 'sitecore',
  initialState,

  reducers: {
    setSiteCoreAPIState: (state, action) => {
      state.isSiteCorePending = !!(action.payload === API_STATUS.LOADING)
    },
    setSiteCore: (state, action) => {
      state.app = action.payload
      state.error = null
    },
    setSiteCoreFailed: (state) => {
      state.app = {}
    },
    setAuthToken: (state, action) => {
      return {
        ...state,
        authToken: action.payload
      }
    },
    setErrorMessage: (state, action) => {
      return {
        ...state,
        errorMessage: action.payload
      }
    }
  },

})

export const { setSiteCore, setSiteCoreFailed, setSiteCoreAPIState, setAuthToken,setErrorMessage } = sitecoreReducer.actions

const getAppContents = (state: RootState) => state.sitecore?.app;
const getSitecoreContents = (state: RootState) => state.sitecore;


export const getChatContent = createSelector(
  getAppContents,
  (app: any) => app?.chat || {}
);

export const getAppSettings = createSelector(
  getAppContents,
  (app: any) => app?.app_settings || {}
);
export const getMessages = createSelector(
  getAppContents,
  (app: any) => app?.messages || {}
);


export const getIsSiteCorePending = createSelector(
  getSitecoreContents,
  (sitecore: any) => sitecore?.isSiteCorePending
);

export const getAuthToken = createSelector(
  getSitecoreContents,
  (sitecore: any) => sitecore?.authToken
);

export const getErrorMessage = createSelector(
  getSitecoreContents,
  (sitecore: any) => sitecore?.errorMessage
);


// if need to use any kind of reducer exports can be done below
//export const {  } = sitecore.actions
export default sitecoreReducer.reducer